// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__RIGWD","option":"Radio_option__2ZZRu","radioCir":"Radio_radioCir__dQmHE","radioTxt":"Radio_radioTxt__3BxBz","selected":"Radio_selected__IrB6s"};